import _get from "lodash/get";
export var getTrackingState = function getTrackingState(identity) {
  return _get(identity, 'tracking', null);
};
export var getTrackingAuthTypeUsed = function getTrackingAuthTypeUsed(identity) {
  return _get(identity, 'tracking.authTypeUsed');
};
export var getTrackingLastTUAuthenticateResult = function getTrackingLastTUAuthenticateResult(identity) {
  return _get(identity, 'tracking.lastTUAuthenticateResult');
};
export var getTrackingHasTUCustomerCreated = function getTrackingHasTUCustomerCreated(identity) {
  return _get(identity, 'tracking.tuCustomerCreated');
};
export var getTrackingCreditPurpose = function getTrackingCreditPurpose(identity) {
  return _get(identity, 'tracking.creditPurpose');
};
export var getTrackingTUVerificationType = function getTrackingTUVerificationType(identity) {
  return _get(identity, 'tracking.tuVerificationType');
};